import _ from "lodash";
import {
  COORD_BY_REGION,
  LOCALE_BY_REGION,
  NONE_REGION_POLICY,
  AVAIL_TABLE,
  AVAIL_TABLE_BY_REGION,
  REGION,
  NONE_SG_POLICIES,
  AVAILABLE_REGION,
  REGION_BY_LOCALE,
  LOCALE_TYPE,
} from "./assets/constants";

export function someIncludes(arr, item) {
  return _.some(arr, (l) => _.includes(_.toLower(item), _.toLower(l)));
}
export function normalizeLocale(locale) {
  if (someIncludes(["et"], locale)) {
    return "et";
  }

  if (someIncludes(["vi", "vn"], locale)) {
    return "vn";
  }

  if (someIncludes(["zh_hans", "zh-rCN", "zh_rCN", "hans", "zh-CN"], locale)) {
    return "zh-CN";
  }
  if (
    someIncludes(
      ["zh_hant", "zh-rHK", "zh_rHK,", "hant", "zh-TW", "tw", "zh-rTW"],
      locale
    )
  ) {
    return "zh-TW";
  }
  if (someIncludes(["ko", "kr", "ko-KR"], locale)) {
    return "ko";
  }
  if (someIncludes(["ja", "jp", "ja-JP"], locale)) {
    return "jp";
  }
  if (someIncludes(["km", "kh"], locale)) {
    return "kh";
  }
  if (someIncludes(["th"], locale)) {
    return "th";
  }

  return "en";
}

export function normalizeProduct(productName) {
  if (
    _.includes(
      [
        "easi6",
        "easi6_booking",
        "easi6_privacy",
        "easi6_rental",
        "easi6_platform_partner",
        "tada_privacy",
        "tada_terms",
        "tada_driver_codes",
        "tada_driver_terms",
        "tada_driver_privacy",
        "mvl_terms",
        "wallet_terms",
        "mvltaxi_driver_terms",
        "delivery_terms",
        "quiks_driver_terms",
        "quiks_delivery_terms",
        "quiks_privacy",
        "community_guideline",
      ],
      productName
    )
  ) {
    return productName;
  } else {
    return "mvl_terms";
  }
}

export const validateRegion = (region) =>
  AVAILABLE_REGION.includes(region) ? region : "";

export async function policyCheck(productName, locale, regionParam) {
  const currentRegion = await getCurrentRegion();
  const region =
    regionParam ||
    currentRegion ||
    (locale === LOCALE_TYPE.KO ? REGION.SG : REGION_BY_LOCALE[locale].at(0)) ||
    REGION.SG;

  //region 정보가 없는 policy 처리
  if (NONE_REGION_POLICY.includes(productName)) {
    if (AVAIL_TABLE[productName].includes(locale)) {
      return `${productName}_${locale}`;
    }

    if (AVAIL_TABLE[productName]) {
      return `${productName}_${AVAIL_TABLE[productName][0]}`;
    }

    return `${productName}_en`;
  }

  const availTableByRegion = AVAIL_TABLE_BY_REGION[region];
  //region 정보가 있는 policy 처리
  if (availTableByRegion) {
    if (availTableByRegion[locale].includes(productName)) {
      return `${productName}_${locale}_${region}`;
    }

    if (availTableByRegion[LOCALE_BY_REGION[region]].includes(productName)) {
      return `${productName}_${LOCALE_BY_REGION[region]}_${region}`;
    }

    if (availTableByRegion["en"].includes(productName)) {
      return `${productName}_en_${region}`;
    }

    if (AVAIL_TABLE_BY_REGION[REGION.SG]["en"].includes(productName)) {
      return `${productName}_en_SG`;
    }

    if (NONE_SG_POLICIES.includes(productName)) {
      if (productName === "wallet_terms") {
        return `${productName}_en_KH`;
      }

      return `${productName}_et_ET`;
    }
  }
}

export const getCurrentLocation = () =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });

export const getRegionUsingCoords = (lat, lon) =>
  Object.keys(COORD_BY_REGION).find((key) => {
    const { SW, NE } = COORD_BY_REGION[key];
    return lat >= SW.lat && lon >= SW.lon && lat <= NE.lat && lon <= NE.lon;
  });

export const getCurrentRegion = async () => {
  // catch error when denied Geolocation
  try {
    const { coords: position } = await getCurrentLocation();
    return getRegionUsingCoords(position.latitude, position.longitude);
  } catch (e) {
    return null;
  }
};

export const sendIsScrollTopToApp = () => {
  const isScrollTop = window.scrollY === 0;

  // Android
  if (window.android && window.android.getIsScrollTop) {
    window.android.getIsScrollTop(isScrollTop);
  }
};

export const throttle = (func, limit) => {
  let lastFunc;
  let lastRan;

  return function (...args) {
    const context = this;

    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};



// WEBPACK FOOTER //
// ./src/Util.js